<section
	#persuadeRef
	*ngrxLet="isMobile$ as isMobile"
	[attr.aria-label]="title()"
	class="card card-xs card-no-padding relative flex size-full flex-col"
	data-test-class="persuade-card"
	role="complementary"
>
	<div
		[ngClass]="{ 'md:flex-row': !useVerticalCard() }"
		class="flex h-full flex-col"
	>
		<div
			[class]="
				cn(
					!useVerticalCard() ? 'md:grow md:flex-row' : '',
					iconList().length > 0 &&
						useVerticalCard() &&
						(!price()?.amount === null || price()?.amount <= 0)
						? 'pb-0'
						: ''
				)
			"
			class="card-inner-xs flex flex-col"
		>
			@if (images()?.length > 0) {
				<div
					[ngClass]="{
						'md:max-w-64 md:basis-1/3': !useVerticalCard(),
					}"
				>
					<vp-persuade-card-media
						[dynamicHeight]="
							!isMobile && !useVerticalCard() ? height : 0
						"
						[imageRibbon]="imageRibbon()"
						[images]="images()"
						[isTransparentImage]="isTransparentImage()"
						[useVerticalCard]="useVerticalCard()"
						[variant]="imageVariant()"
						aspectRatio="3:2"
						class="pb-0"
					/>
				</div>
			}

			<div
				[class]="
					cn(
						!useVerticalCard() && images()?.length > 0
							? 'md:basis-2/3'
							: 'basis-full',
						iconList().length > 0 && useVerticalCard()
							? 'pb-0'
							: 'gap-5 pb-4'
					)
				"
				class="flex flex-col items-start p-3"
			>
				@if (title() || iconList().length > 0) {
					<div class="w-full">
						@if (title()) {
							<vp-persuade-card-header
								[cardLinkType]="cardLinkType()"
								[cardQueryParams]="cardUrlQueryParams()"
								[cardTarget]="secondaryCtaTarget()"
								[cardUrl]="cardUrl()"
								[headingType]="headingType()"
								[overline]="overline()"
								[title]="title()"
							/>
						}
						@if (iconList().length > 0) {
							<vp-icon-list
								[iconColor]="iconColor()"
								[isHorizontal]="isHorizontalIconList()"
								[items]="iconList()"
								data-test-id="persuade-card-icons"
							/>
						}
					</div>
				}

				@if (socialProof()?.score) {
					<vp-social-proof
						[numberOfRatings]="socialProof().numberOfRatings"
						[rating]="socialProof().score"
						[size]="isMobile ? 'sm' : 'base'"
					/>
				}

				<div class="w-full">
					@if (content()) {
						<markdown
							[data]="content()"
							class="list-checkmarks markdown"
							data-test-id="persuade-card-description"
						/>
					} @else {
						<div data-test-id="persuade-card-content">
							<ng-content select="[content]" />
						</div>
					}

					@if (showReadMore() && cardUrl()) {
						<valk-core-smart-link
							[className]="'text-link'"
							[linkType]="cardLinkType()"
							[queryParams]="cardUrlQueryParams()"
							[testId]="'persuade-card-link'"
							[url]="cardUrl()"
						>
							{{ readMoreText() | translate }}
						</valk-core-smart-link>
					}

					@if (tags()?.length > 0) {
						<div class="mt-6 inline-flex w-full flex-wrap gap-1.5">
							@for (tag of tags(); track tag) {
								<vp-tag color="light-lime">{{ tag }}</vp-tag>
							}
						</div>
					}
				</div>
			</div>
		</div>

		@let linkList = linkListConfig();
		@let showLinkList = (linkList?.items?.length ?? 0) > 0;

		@if (showFooterArea()) {
			<div
				[ngClass]="{
					'md:w-fit': !useVerticalCard(),
					'mt-auto': useVerticalCard(),
				}"
				data-test-id="footer-content"
			>
				@let baseLayout =
					useVerticalCard()
						? 'w-full'
						: 'h-full w-full md:w-36 lg:w-48 md:flex-col';

				@let padding =
					useVerticalCard()
						? showLinkList
							? 'p-0'
							: 'px-5 pb-5 pt-0'
						: showLinkList
							? 'p-0 md:px-0'
							: 'px-5 pb-5 pt-0 md:px-0 md:pt-5 md:mr-5';

				<div
					[class]="
						cn(
							'flex flex-col justify-between gap-4',
							baseLayout,
							padding,
							reversedCtaColumn() &&
								!useVerticalCard() &&
								'md:flex-col-reverse'
						)
					"
				>
					@if (
						price() &&
						(price()?.amount === null || price()?.amount > 0)
					) {
						<vp-pricing
							*ngrxLet="isTablet$ as isTablet"
							[alignment]="
								isMobile || isTablet || useVerticalCard()
									? 'self-start'
									: 'self-end'
							"
							[conditions]="pricingConditionByType() | translate"
							[currency]="price()?.currency || 'EUR'"
							[indication]="true"
							[ngClass]="{ 'md:ml-auto': !useVerticalCard() }"
							[price]="
								price().type === 'perPerson' ||
								price().type === 'perNight'
									? price().displayAmount
									: price().amount
							"
							[pricingToolTip]="
								pricingToolTip() &&
								(price()?.charges !== null ||
									price()?.charges > 0) && {
									total: price().amount,
									occupancy: pricingToolTip().occupancy,
									dateRange: price()?.dateRange,
									items: pricingToolTip()?.items?.length
										? pricingToolTip().items
										: [
												{
													name: title(),
													price: price()
														?.amountExcludingCharges,
												},
											],
									taxes: { tourist: price()?.charges },
								}
							"
							[requestPrice]="price().onRequest"
							[size]="isMobile || isTablet ? 'sm' : 'base'"
							class="ml-0"
						/>
					} @else if (
						price()?.amount !== null && price().amount <= 0
					) {
						<div
							[ngClass]="{ 'md:ml-auto': !useVerticalCard() }"
							class="flex items-center gap-1"
							data-test-id="price-type"
						>
							<svg-icon
								class="icon-container icon-container-accent"
								src="assets/icons/icon-deal.svg"
							/>
							{{ 'components.pricing.free' | translate }}
						</div>
					}
					@if (hasFooterContent()) {
						<div data-test-id="persuade-card-footer">
							<ng-content select="[footerContent]" />
						</div>
					}

					@if (ctaUrl()) {
						<div
							[ngClass]="{ 'md:self-end': !useVerticalCard() }"
							class="mt-auto flex flex-col gap-2"
						>
							@if (secondaryCtaText()) {
								<valk-core-smart-link
									[className]="
										cn(
											'btn btn-sm w-full md:btn md:w-full',
											secondaryCtaVariant()
										)
									"
									[linkType]="secondaryCtaLinkType()"
									[queryParams]="cardUrlQueryParams()"
									[target]="secondaryCtaTarget()"
									[testId]="'persuade-card-cta-secondary'"
									[url]="cardUrl()"
								>
									{{ secondaryCtaText() | translate }}
								</valk-core-smart-link>
							}
							<valk-core-smart-link
								[className]="
									cn(
										'btn btn-sm w-full md:btn md:w-full',
										ctaPrimaryClasses()
									)
								"
								[linkType]="ctaLinkType()"
								[target]="ctaTarget()"
								[testId]="'persuade-card-cta'"
								[url]="ctaUrl()"
							>
								{{ ctaText() | translate }}
							</valk-core-smart-link>
						</div>
					}

					@if (showLinkList) {
						<vp-link-list
							[linkListItems]="linkList!.items"
							[showBorderTop]="true"
							[showDivider]="linkList!.showDivider"
							[showIcons]="linkList!.showIcons"
							[useChevron]="linkList!.useChevron"
							class="mt-auto"
						/>
					}
				</div>
			</div>
		}
	</div>
</section>
